import React from 'react';
import { useNavigate } from 'react-router-dom';
import styled from 'styled-components';
import MainHeader from '../Components/MainHeader';

const VaccineContainer = styled.div`
  min-height: 100vh;
  background-color: #f8f9fa;
  font-family: 'Noto Sans Thai', sans-serif !important;
  * {
    font-family: 'Noto Sans Thai', sans-serif !important;
    font-weight: normal;
    color: #666666;
  }
`;

const Header = styled.div`
  background-color: #00BBD3;
  padding: 16px 24px;
  color: white;
  font-size: 18px;
  font-weight: bold;
  font-family: 'Noto Sans Thai', sans-serif !important;
  max-width: 480px;
  margin: 0 auto;
  width: 100%;
  box-sizing: border-box;
`;

const BackButton = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 16px 24px;
  cursor: pointer;
  font-size: 16px;
  color: #B0B0B0;
  font-family: 'Noto Sans Thai', sans-serif !important;
  
  &:hover {
    color: #666666;
  }
`;

const BackIcon = styled.span`
  font-size: 16px;
  color: #B0B0B0;
`;

const Content = styled.div`
  padding: 24px;
  max-width: 480px;
  margin: 0 auto;
  width: 100%;
  box-sizing: border-box;
`;

const TitleSection = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 16px;
  margin-bottom: 32px;
`;

const VaccineIcon = styled.img`
  width: 48px;
  height: 48px;
  object-fit: contain;
`;

const TitleText = styled.h1`
  font-size: 20px;
  font-weight: bold;
  color: #333333;
  margin: 0;
  font-family: 'Noto Sans Thai', sans-serif !important;
`;

const TableContainer = styled.div`
  background-color: white;
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
`;

const TableHeader = styled.div`
  background-color: #00BBD3;
  padding: 16px 20px;
  display: flex;
  color: white;
  font-weight: bold;
  font-family: 'Noto Sans Thai', sans-serif !important;
`;

const HeaderColumn1 = styled.div`
  flex: 1;
  font-size: 16px;
  color: white;
`;

const HeaderColumn2 = styled.div`
  flex: 2;
  font-size: 16px;
  color: white;
`;

const TableRow = styled.div`
  padding: 20px;
  border-bottom: 1px solid #f0f0f0;
  display: flex;
  
  &:last-child {
    border-bottom: none;
  }
`;

const DateColumn = styled.div`
  flex: 1;
  font-size: 16px;
  font-weight: bold;
  color: #333333;
  font-family: 'Noto Sans Thai', sans-serif !important;
`;

const DetailColumn = styled.div`
  flex: 2;
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

const VaccineTitle = styled.div`
  font-size: 16px;
  font-weight: bold;
  color: #333333;
  font-family: 'Noto Sans Thai', sans-serif !important;
`;

const VaccineSubtitle = styled.div`
  font-size: 14px;
  color: #B0B0B0;
  font-family: 'Noto Sans Thai', sans-serif !important;
`;

const VaccineStatus = styled.div`
  font-size: 14px;
  font-family: 'Noto Sans Thai', sans-serif !important;
  
  &.urgent {
    color: #ff4757;
  }
  
  &.completed {
    color: #2ed573;
  }
`;

const VaccineNotificationPage = () => {
  const navigate = useNavigate();

  const vaccineData = [
    {
      date: '23/10/25',
      title: 'วัคซีนไข้หวัดใหญ่',
      subtitle: 'มาก่อนเวลานัด 1 ชั่วโมง',
      status: 'รอดำเนินการฉีด',
      statusType: 'urgent'
    },
    {
      date: '12/6/25',
      title: 'วัคซีนป้องกันไวรัสตับอักเสบบี',
      subtitle: 'มาก่อนเวลานัด 1 ชั่วโมง',
      status: 'ฉีดสำเร็จ',
      statusType: 'completed'
    },
    {
      date: '4/2/25',
      title: 'มีนัดฉีดวัคซีนป้องกันโรคคอตีบ ไอกรน บาดทะยัก',
      subtitle: 'มาก่อนเวลานัด 1 ชั่วโมง',
      status: 'ฉีดสำเร็จ',
      statusType: 'completed'
    }
  ];

  const handleBackClick = () => {
    navigate('/dashboard');
  };

  return (
    <VaccineContainer>
      <MainHeader />

      <Header>
        แจ้งเตือนการฉีดวัคซีน
      </Header>
      
      <BackButton onClick={handleBackClick}>
        <BackIcon>‹</BackIcon>
        <span>ย้อนกลับ</span>
      </BackButton>

      <Content>
        <TitleSection>
          <VaccineIcon src="./เข็มฉีดยา.png" alt="Vaccine Icon" />
          <TitleText>นัดฉีดวัคซีนของท่าน</TitleText>
        </TitleSection>

        <TableContainer>
          <TableHeader>
            <HeaderColumn1>วันที่ฉีด</HeaderColumn1>
            <HeaderColumn2>ชื่อวัคซีน</HeaderColumn2>
          </TableHeader>
          
          {vaccineData.map((vaccine, index) => (
            <TableRow key={index}>
              <DateColumn>{vaccine.date}</DateColumn>
              <DetailColumn>
                <VaccineTitle>{vaccine.title}</VaccineTitle>
                <VaccineSubtitle>{vaccine.subtitle}</VaccineSubtitle>
                <VaccineStatus className={vaccine.statusType}>
                  สถานะ: {vaccine.status}
                </VaccineStatus>
              </DetailColumn>
            </TableRow>
          ))}
        </TableContainer>
      </Content>
    </VaccineContainer>
  );
};

export default VaccineNotificationPage;